import { Button, DialogContent, Dialog, DialogTitle } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import MembersCard from "../components/Canvas";
import { WarningIcon } from "../svg/WarningIcon";
import UseInfoMain from "../components/UseInfoMain";
import UseInfoPassport from "../components/UseInfoPassport";
import UseInfoOthers from "../components/UseInfoOthers";
import PictureUpload from "../components/PictureUpload";
import UseInfoEmail from "../components/UseInfoEmail";
import UserInfoEmergency from "../components/UserInfoEmergency";
import { Link } from 'react-router-dom';
import HeaqderNav from "../components/HeaqderNav";
import { imgPath, TokenContext, restPath, nearExpiry, prefix } from './../App';

const UserInfo = () => {
  const token = useContext(TokenContext);
  const storedData = sessionStorage.getItem("jacUserCore");
  const [userInfo, setUserInfo] = useState([]);
  const [verifying, setVerifying] = useState(false);

  const [currentEmail, setCurrentEmail] = useState(null);

  useEffect(() => {
    if (storedData && currentEmail === null) {
      setUserInfo(JSON.parse(storedData));
      setCurrentEmail(JSON.parse(storedData).email)
    }
  }, [])


  useEffect(() => {

    if (!userInfo?.id) return;
    if (userInfo?.img) return;
    const fetchData = async () => {

      try {
        const res = await fetch(`${restPath}/wp-json/base64/v1/getImgData?id=${userInfo?.id}`);
        const data = await res.json();
        if (data.status === "success") {
          const base64 = data?.imgData?.base64 || null;

          const updatedUser = { ...userInfo, img: base64 };
          sessionStorage.setItem("jacUserCore", JSON.stringify(updatedUser));
          setUserInfo(prev => ({ ...prev, img: base64 }));
        } else {
          console.error("取得失敗:", data.message);
          return null;
        }

      } catch (err) {
        console.error("画像取得失敗:", err);
      }
    };

    fetchData();


  }, [userInfo])

  const Sticky = () => {
    if (userInfo.membership === 'invalid') {
      const classes = userInfo.membership === `invalid` ? `sticky red` : `sticky red bottom`
      return <p className={classes}>
        <WarningIcon></WarningIcon>
        有効期限が切れています
        <Button
          component={Link}
          to="/payment/"
          style={{ background: `var(--yellow)`, border: `none`, color: `#000`, height: `40px`, width: `100px`, borderRadius: `4px`, fontWeight: `bold` }}
        >
          更新する
        </Button>
      </p>
    }
    else if (nearExpiry(userInfo.expiry) && (userInfo.membership === `supporting` || userInfo.membership === `end_paypal_subscription`)) {
      return <p className={`sticky`}>
        <WarningIcon></WarningIcon>
        有効期限が近づいています
        <Button
          component={Link}
          to="/payment/"
          style={{ background: `var(--red)`, border: `none`, color: `#fff`, height: `40px`, width: `100px`, borderRadius: `4px`, fontWeight: `bold` }}
        >
          更新する
        </Button>
      </p>

    }
  }

  const BackImage = () => {
    if (userInfo.membership === 'invalid') {
      return <img src={`${imgPath}/images/expired.svg`} className="bg-img" alt="" />
    }
    else if (userInfo.membership === 'temporary') {
      return <img src={`${imgPath}/images/temporary.svg`} className="bg-img" alt="" />
    }
  }
  console.log(userInfo)

  return <>
    <HeaqderNav></HeaqderNav>
    <ul className="breadcrumb">
      <li>
        会員情報
      </li>
    </ul>
    <BackImage></BackImage>
    <dl className="dl">
      <dt>有効期限</dt>
      <dd style={
        userInfo.membership === `invalid`
          ? { opacity: 0.3 }
          : {
            color: nearExpiry(userInfo.expiry) ? 'var(--red)' : 'inherit',
            fontWeight: nearExpiry(userInfo.expiry) ? 'bold' : 'normal',
          }
      }>
        {userInfo.expiry}
      </dd>
    </dl>

    <p style={{ margin: `16px auto` }}>
      <img src={userInfo.membership !== 'invalid' ? userInfo.img : `${imgPath}/images/dummy.jpg`} alt="" width={100} height={110} />
    </p>
    <dl className="dl" style={{ marginBottom: `54px` }}>
      <dt>会員番号</dt>
      <dd>
        {userInfo.id}
      </dd>
      <dt>メールアドレス</dt>
      <dd>{userInfo.email}</dd>
      <dt>名前</dt>
      <dd>
        <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
          {userInfo.familyName}{" "}
          {userInfo.middleName ? userInfo.middleName + " " : ""}
          {userInfo.firstName}
        </span>
      </dd>
      <dt>ローマ字</dt>
      <dd>
        <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
          {userInfo.firstNameEn}{" "}
          {userInfo.middleNameEn ? userInfo.middleNameEn + " " : ""}
          {userInfo.familyNameEn}
        </span>
      </dd>
      <dt>誕生日</dt>
      <dd>
        {userInfo.birthday}
      </dd>
    </dl>

    {userInfo.membership !== 'invalid' && <div>
      <p style={{ textAlign: `center`, marginTop: `12px`, marginBottom: `52px` }}>
        <Button component={Link} to="/user-info/edit" style={{ background: `var(--blue)`, color: `#fff`, fontSize: `18px` }} sx={{ width: "250px" }} > 詳細 / 修正</Button>
      </p>
      <MembersCard userData={userInfo}></MembersCard>
    </div>

    }

    <Sticky></Sticky>
    {verifying && <div className="register"><img src={`${imgPath}/images/spinner.svg`} alt="" width={100} height={110} /></div>}

  </>

}
export default UserInfo;
